/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Bell_HintInputs */

const cs_pm_bell_hint = /** @type {(inputs: Pm_Bell_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránku můžete zavřít, výsledek najdete ve zvonečku.`)
};

const en_pm_bell_hint = /** @type {(inputs: Pm_Bell_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can leave this page; the result shows in the bell.`)
};

/**
* | output |
* | --- |
* | "You can leave this page; the result shows in the bell." |
*
* @param {Pm_Bell_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_bell_hint = /** @type {((inputs?: Pm_Bell_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Bell_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_bell_hint(inputs)
	return cs_pm_bell_hint(inputs)
});